import { takeLatest, call, put, all } from 'redux-saga/effects';

import { 
	fetchCompareFunds,
	fetchGraphCompareFunds,
	fetchCompareFundsByPeriod
} from '../_services/compare.services';

import { fetchNavForAdvanceSearch } from '../_services/advance-search.services';
import { 
	fetchCompareFundsSuccess, 
	fetchCompareFundsFailure,
	fetchCompareFundsByPeriodSuccess,
	fetchCompareFundsByPeriodFailure,
	fetchGraphCompareFundsSuccess,
	fetchGraphCompareFundsFailure,
	fetchNavCompareFundsSuccess,
	fetchNavCompareFundsFailure,
	clearCompareFund
} from '../_actions/compare.actions';
import { compareConstants } from '../_constants/compare.constants';

export function* fetchCompareFundsAsync({ payload }) {
	try {
		// yield put(clearCompareFund());
		const result = yield call(fetchCompareFunds, payload);
		yield put(fetchCompareFundsSuccess(result.data));
	} catch (error) {
		yield put(fetchCompareFundsFailure(error));
	}
}

export function* fetchCompareFundsStart() {
	yield takeLatest(compareConstants.FETCH_COMPARE_START, fetchCompareFundsAsync);
}

export function* fetchCompareFundsByPeriodAsync({ payload }) {
	try {
		const result = yield call(fetchCompareFundsByPeriod, payload);
		yield put(fetchCompareFundsByPeriodSuccess(result.data));
	} catch (error) {
		yield put(fetchCompareFundsByPeriodFailure(error));
	}
}

export function* fetchCompareFundsByPeriodStart() {
	yield takeLatest(compareConstants.FETCH_COMPARE_FUNDS_BY_PERIOD_START, fetchCompareFundsByPeriodAsync);
}

export function* fetchGraphCompareFundsAsync({ payload }) {
	try {
		// yield put(clearCompareFund());
		const result = yield call(fetchGraphCompareFunds, payload);
		yield put(fetchGraphCompareFundsSuccess(result.data));
	} catch (error) {
		yield put(fetchGraphCompareFundsFailure(error));
	}
}

export function* fetchGraphCompareFundsStart() {
	yield takeLatest(compareConstants.FETCH_GRAPH_COMPARE_FUNDS_START, fetchGraphCompareFundsAsync);
}

export function* fetchNavCompareFundsAsync({ payload }) {
	try {
		const result = yield call(fetchNavForAdvanceSearch, payload);
		yield put(fetchNavCompareFundsSuccess(result.data));
	} catch (error) {
		yield put(fetchNavCompareFundsFailure(error));
	}
}

export function* fetchNavCompareFundsStart() {
	yield takeLatest(compareConstants.FETCH_NAV_COMPARE_FUNDS_START, fetchNavCompareFundsAsync);
}

export function* compareSagas() {
	yield all([
		call(fetchCompareFundsStart),
		call(fetchCompareFundsByPeriodStart),
		call(fetchGraphCompareFundsStart),
		call(fetchNavCompareFundsStart)
	]);
}
